<div *ngIf="areTheInitialRegistrationStepsIncomplete()" class="bar-and-steps-wrapper row mt-3 mb-2 mx-auto">
  <!--Step1-->
  <div class="col-12 col-sm-3 p-0 m-0">
    <div
      class="text-center progress-bar-step me-0 d-flex flex-column justify-content-center first"
      [ngClass]="
        !isFullNameRegistrationCompleted &&
        !isPetChipNumberRegistrationCompleted &&
        !isMembershipSelectionCompleted &&
        !isWelcomePackSelectCompleted
          ? 'progress-bar-step-completed'
          : ''
      "
    >
      <span class="progress-bar-special-text ms-0">Your details</span>
    </div>
  </div>

  <!--Step2-->
  <div class="col-12 col-sm-3 p-0 m-0">
    <div
      class="text-center progress-bar-step me-0 d-flex flex-column justify-content-center second"
      [ngClass]="
        isFullNameRegistrationCompleted &&
        !isPetChipNumberRegistrationCompleted &&
        !isMembershipSelectionCompleted &&
        !isWelcomePackSelectCompleted
          ? 'progress-bar-step-completed'
          : ''
      "
    >
      <span class="progress-bar-special-text ms-3 ms-sm-0">Pet details</span>
    </div>
  </div>

  <!--Step3-->
  <div *ngIf="isMembershipSelectionStepAvailable" class="col-12 col-sm-3 p-0 m-0">
    <div
      class="text-center progress-bar-step me-0 d-flex flex-column justify-content-center third"
      [ngClass]="
        isFullNameRegistrationCompleted &&
        isPetChipNumberRegistrationCompleted &&
        !isMembershipSelectionCompleted &&
        !isWelcomePackSelectCompleted
          ? 'progress-bar-step-completed'
          : ''
      "
    >
      <span class="progress-bar-special-text ms-3 ms-sm-0">Select plan</span>
    </div>
  </div>

  <!--Step4-->
  <ng-container *appFeatureFlag="'isPetPlanFreeInsuranceStep4Available'">
    <div *ngIf="isWelcomeGiftStepAvailable" class="col-12 col-sm-3 p-0 m-0">
      <div
        class="text-center progress-bar-step me-0 d-flex flex-column justify-content-center last"
        [ngClass]="
          isFullNameRegistrationCompleted &&
          isPetChipNumberRegistrationCompleted &&
          isMembershipSelectionCompleted &&
          !isWelcomePackSelectCompleted
            ? 'progress-bar-step-completed'
            : ''
        "
      >
        <span class="progress-bar-special-text ms-3 ms-sm-0">4 weeks free<br class="d-none d-sm-block d-lg-none"> pet insurance</span>
      </div>
    </div>
  </ng-container>
</div>
